// noinspection JSFileReferences
import Moment from 'daterangepicker/moment.min.js'
import Is from './is.js'

export default class Date
{
	static init()
	{
		this.date_picker()
		this.time_picker()

		this.datetime_picker()
		this.daterange_picker()
	}

	static date_picker()
	{
		$('input.__date').each((index, element) =>
		{
			const option = {
				locale          : {
					format    : 'YYYY-MM-DD',
					daysOfWeek: ['日', '月', '火', '水', '木', '金', '土'],
					monthNames: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
				},
				autoUpdateInput : false,
				autoApply       : true,
				singleDatePicker: true,
				showDropdowns   : true,
			}

			const min_date = $(element).data('min-date')
			if(Is.filled(min_date)) option.minDate = min_date

			$(element).daterangepicker(option)

			$(element).on('apply.daterangepicker', function(event, picker)
			{
				$(this).val(picker.startDate.format('YYYY-MM-DD'))
				this.dispatchEvent(new Event('change'))
			})
		})
	}

	static time_picker()
	{
		$('input.__time').each((index, element) =>
		{
			$(element).daterangepicker({
				timePicker         : true,
				timePicker24Hour   : true,
				timePickerIncrement: 15,
				singleDatePicker   : true,
				locale             : {
					format     : 'HH:mm',
					applyLabel : '適用',
					cancelLabel: 'キャンセル',
				},
			}).on('show.daterangepicker', function(_, picker)
			{
				picker.container.find('.calendar-table').hide()
			})
		})
	}

	static datetime_picker()
	{
		const picker = $('input.__datetime')
		const use_clear = picker.data('daterangepicker-clear') === 1

		const option = {
			locale             : {
				format     : 'YYYY-MM-DD HH:mm',
				daysOfWeek : ['日', '月', '火', '水', '木', '金', '土'],
				monthNames : ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
				cancelLabel: use_clear ? '削除' : 'キャンセル',
				applyLabel : '適用',
			},
			autoUpdateInput    : false,
			singleDatePicker   : true,
			timePicker         : true,
			timePicker24Hour   : true,
			minYear            : 2022,
			timePickerIncrement: 5,
		}

		const min_date = picker.data('min-date')
		if(Is.filled(min_date)) option.minDate = min_date

		picker.daterangepicker(option)

		picker.on('apply.daterangepicker', function(event, picker)
		{
			$(this).val(picker.startDate.format('YYYY-MM-DD HH:mm'))
			this.dispatchEvent(new Event('change'))
		})

		if(use_clear)
		{
			picker.on('cancel.daterangepicker', function()
			{
				$(this).val('')
				this.dispatchEvent(new Event('change'))
			})
		}
	}

	static daterange_picker()
	{
		$('input.__daterange').each((index, element) =>
		{
			// noinspection NonAsciiCharacters
			$(element).daterangepicker({
				startDate            : $(element).data('start'),
				endDate              : $(element).data('end'),
				ranges               : {
					'今日': [Moment(), Moment()],
					'昨日': [Moment().subtract(1, 'day'), Moment().subtract(1, 'day')],
					'今週': [Moment().startOf('week'), Moment().endOf('week')],
					'先週': [Moment().subtract(1, 'week').startOf('week'), Moment().subtract(1, 'week').endOf('week')],
					'今月': [Moment().startOf('month'), Moment().endOf('month')],
					'先月': [Moment().subtract(1, 'month').startOf('month'), Moment().subtract(1, 'month').endOf('month')],
				},
				'alwaysShowCalendars': true,
				locale               : {
					format          : 'YYYY-MM-DD',
					customRangeLabel: '期間指定',
					applyLabel      : '適用',
					cancelLabel     : 'キャンセル',
					daysOfWeek      : ['日', '月', '火', '水', '木', '金', '土'],
					monthNames      : ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
				},
				minYear              : 2022,
			})
		})
	}
}
